import type { CollectionParentUpdatedEvent } from '@indigohive/cogfy-types/events/collectionParentUpdated'
import { CollectionCreatedEvent } from '@indigohive/cogfy-types/events/collectionCreated'
import { BaseClient, BaseClientOptions } from './base-client'
import { SocketEvent } from '../socket'

export class CollectionsClient extends BaseClient {
  onCollectionCreated: SocketEvent<CollectionCreatedEvent>
  onCollectionParentUpdated: SocketEvent<CollectionParentUpdatedEvent>

  constructor (options: BaseClientOptions) {
    super(options)

    this.onCollectionCreated = new SocketEvent(this.socket, 'collection_created')
    this.onCollectionParentUpdated = new SocketEvent(this.socket, 'collection_parent_updated')
  }

  exportCsvUrl (
    workspaceSlug: string,
    collectionId: string,
    token: string,
    viewId?: string | null
  ): string {
    return this.axios.defaults.baseURL + `/exportCollectionToCsv?workspace=${workspaceSlug}&collectionId=${collectionId}&viewId=${viewId}&token=${token}`
  }

  exportXlsxUrl (
    workspaceSlug: string,
    collectionId: string,
    token: string,
    viewId?: string | null
  ): string {
    return this.axios.defaults.baseURL + `/exportCollectionToXlsx?workspace=${workspaceSlug}&collectionId=${collectionId}&viewId=${viewId}&token=${token}`
  }
}
